"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSignOut = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M7.414 10.512H15c.667 0 1 .333 1 1s-.333 1-1 1H7.414l3.293 3.293a1 1 0 11-1.414 1.414l-5-5a1 1 0 010-1.414l5.001-5.001a1 1 0 011.414 1.414l-3.294 3.294zM20 18c0 1.333-.667 2-2 2h-1.995c-.67.021-1.005-.312-1.005-1s.335-1.021 1.005-1H18V6h-1.902C15.366 6 15 5.667 15 5s.372-1 1.116-1H18c1.324 0 1.991.668 2 2.004V18z' }))); };
exports.default = SvgSignOut;
//# sourceMappingURL=SignOut.js.map